"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mutateUserDetailsCustomData = exports.requestUserDetailsCustomData = void 0;
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const userDetailsCustomDataQuery = (0, graphql_tag_1.default) `
query UserDetailsCustomData($workspaceId: ID!, $userId: ID!) {
  role(workspace: $workspaceId, user: $userId) {
    customData {
      telephone
      note
      managedByPlugin
      lastUpdateFromPlugin
      lastName
      firstName
      employeeId
      birthdate
      address
    }
  }
}`;
const userDetailsCustomDataMutation = (0, graphql_tag_1.default) `
mutation UpdateUserDetailsCustomData($workspaceId: ID!, $userId: ID!, $data: RoleInputData) {
  roleUpdate(workspace: $workspaceId, user: $userId, data: $data) {
    customData {
      telephone
      note
      managedByPlugin
      lastName
      kmToWork
      firstName
      employeeId
      birthdate
      address
    }
  }
}`;
const requestUserDetailsCustomData = async ({ workspaceId, userId, }) => {
    const { data, errors } = await (0, apollo_1.query)(userDetailsCustomDataQuery, {
        variables: {
            workspaceId, userId,
        },
    });
    (0, error_handler_1.processErrors)(errors);
    return data?.role;
};
exports.requestUserDetailsCustomData = requestUserDetailsCustomData;
const mutateUserDetailsCustomData = async ({ workspaceId, userId, data: _data, }) => {
    const { data, errors } = await (0, apollo_1.mutate)(userDetailsCustomDataMutation, {
        variables: {
            workspaceId, userId, data: _data,
        },
    });
    (0, error_handler_1.processErrors)(errors);
    return data?.roleUpdate;
};
exports.mutateUserDetailsCustomData = mutateUserDetailsCustomData;
